import React from 'react'
import { Table } from './Table'
import { Button } from '../Button'
import { useTranslation } from 'utils/useTranslation'

export function Details({ description, specifications, fits, isInCart, onAddToCartClick }) {
  const accessoryStrings = useTranslation('accessories_shop.misc') ?? {}
  return (
    <div className='mtt-details'>
      <div className='mtt-excerpt wysiwyg' dangerouslySetInnerHTML={{ __html: description }} />
      <Table list={specifications} title={accessoryStrings.specifications + ':'} />
      <Table list={fits} title={accessoryStrings.fits_to + ':'} />
      <Button
        classes='primary'
        text={isInCart ? accessoryStrings.remove_from_cart : accessoryStrings.add_to_cart}
        onClick={onAddToCartClick}
      />
    </div>
  )
}
